/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Change_ThemeInputs */

const en_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to change the Land Style:
Go to Settings > Land Style > Select "Cotton Puddles"`)
};

const ar_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيفية تغيير نمط الأرض:
انتقل إلى الإعدادات > نمط الأرض > اختر "برك القطن"`)
};

const de_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So ändern Sie die Land-Stil: Gehen Sie zu Einstellungen > Land-Stil > Wählen Sie "Baumwollpfützen".`)
};

const es_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo cambiar el Estilo de terreno:
Ve a Ajustes > Estilo de terreno > Selecciona "Charcos de algodón"`)
};

const fr_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour changer le Style de sol:
Allez dans Paramètres > Style de sol > Sélectionnez «Nuage de Coton».`)
};

const it_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come cambiare il Stile del terreno: 
Vai a Impostazioni > Stile del terreno > Seleziona "Soffici Pozzanghere"`)
};

const ja_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ランドスタイルの変更方法：
設定 > ランドスタイル >「コットンパッチ」を選択`)
};

const ko_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`랜드 스타일 변경 방법: 
설정 > 랜드 스타일로 이동한 다음 > "폭신폭신 솜뭉치"를 선택하세요`)
};

const pt_br_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como alterar o Estilo de terreno:
Vá para Configurações > Estilo de terreno > Selecione "Tapete de algodão"`)
};

const ru_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как изменить Тему:
Перейдите в Настройки > Стиль земли > Выберите «Хлопковые лужицы»`)
};

const th_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธีเปลี่ยนสไตล์พื้นดิน:
ไปที่ การตั้งค่า > สไตล์พื้นดิน > เลือก "แอ่งปุยเมฆ"`)
};

const tr_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arazi Türü nasıl değiştirilir?
Ayarlar > Arazi Türü > " Pamuk Birikintileri'ni seç"`)
};

const zh_cn_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何更换土地皮肤：
前往设置 > 土地皮肤 > 选择「棉绵水洼」`)
};

const zh_tw_how_to_change_theme = /** @type {(inputs: How_To_Change_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何更換土地造型：
前往設定 > 土地造型 > 選擇「棉綿水窪」`)
};

/**
* | output |
* | --- |
* | "How to change the Land Style: Go to Settings > Land Style > Select \"Cotton Puddles\"" |
*
* @param {How_To_Change_ThemeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_to_change_theme = /** @type {((inputs?: How_To_Change_ThemeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Change_ThemeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_to_change_theme(inputs)
	if (locale === "ar") return ar_how_to_change_theme(inputs)
	if (locale === "de") return de_how_to_change_theme(inputs)
	if (locale === "es") return es_how_to_change_theme(inputs)
	if (locale === "fr") return fr_how_to_change_theme(inputs)
	if (locale === "it") return it_how_to_change_theme(inputs)
	if (locale === "ja") return ja_how_to_change_theme(inputs)
	if (locale === "ko") return ko_how_to_change_theme(inputs)
	if (locale === "pt_br") return pt_br_how_to_change_theme(inputs)
	if (locale === "ru") return ru_how_to_change_theme(inputs)
	if (locale === "th") return th_how_to_change_theme(inputs)
	if (locale === "tr") return tr_how_to_change_theme(inputs)
	if (locale === "zh_cn") return zh_cn_how_to_change_theme(inputs)
	return zh_tw_how_to_change_theme(inputs)
});